// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.trending-search-wrapper {
    /* stylelint-disable max-nesting-depth */
    .trending-search-list {
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      letter-spacing: 0.5px;

      .trending-search-title {
        font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
        margin-bottom: 24px;
        font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
        @media ${(props) => props.theme.mediaQuery.mediumOnly} {
          font-size: ${(props) => props.theme.typography.fontSizes.fs14};
          margin-bottom: 18px;
        }
        @media ${(props) => props.theme.mediaQuery.smallOnly} {
          font-size: ${(props) =>
            props.redesign
              ? props.theme.typography.fontSizes.fs14
              : props.theme.typography.fontSizes.fs16};
          margin-bottom: 20px;
        }
        @media (min-width: 375px) and (max-width: 385px) {
          margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
        }
        @media (max-height: 705px) {
          margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
        }
        @media ${(props) => props.theme.mediaQuery.desktop} {
          font-size: ${(props) => props.theme.typography.fontSizes.fs24};
          line-height: 27px;
        }
        &.redesign {
          font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        }
      }
      .trending-search-items {
        @media ${(props) => props.theme.mediaQuery.smallOnly} {
          padding-bottom: 26px;
          padding-left: 6px;
        }
        @media (min-width: 375px) and (max-width: 385px) {
          padding-bottom: 20px;
        }
        @media (max-height: 705px) {
          padding-bottom: 20px;
        }
      }
      .trending-search-items.redesign {
        @media ${(props) => props.theme.mediaQuery.smallOnly} {
          padding-left: 0;
          padding-bottom: 32px;
        }
      }
      .trending-search-list-item {
        letter-spacing: 0.5px;
        font-size: ${(props) => props.theme.typography.fontSizes.fs16};
        white-space: nowrap;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 16px;
        @media ${(props) => props.theme.mediaQuery.smallOnly} {
          margin-bottom: 8px;
          &:last-child {
            margin-bottom: 0;
          }
        }
        @media ${(props) => props.theme.mediaQuery.mediumMax} {
          font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        }
        @media ${(props) => props.theme.mediaQuery.mediumOnly} {
          margin-bottom: 14px;
          font-size: ${(props) => props.theme.typography.fontSizes.fs12};
        }
        @media ${(props) => props.theme.mediaQuery.desktop} {
          margin-bottom: 22px;
        }
      }
      .trending-search-list-item.redesign {
        font-size: ${(props) => props.theme.typography.fontSizes.fs12};
        font-weight: 500;
        color: #595959;
        letter-spacing: normal;
        @media ${(props) => props.theme.mediaQuery.large} {
          margin-bottom: 16px;
        }
      }
      .trending-search-list-item.mobile-viewport {
        max-width: 295px;
      }
    }
  }
`;
